import React from "react";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";

const LabeledDropdown = ({
  label,
  options = [],
  placeholder,
  visible = true,
  onChange,
  value = [],
  disabled = false,
  isMultiple = false
}) => {
  if (!visible) return null;
  if (
    (label === "District" && disabled) ||
    (label === "Taluka" && disabled) ||
    (label === "PHC Name" && disabled) ||
    (label === "LGB Name" && disabled) ||
    (label === "UPHC Name" && disabled) ||
    (label === "Sub Area" && disabled)
  ) {
    return null;
  }
  return (
    <div style={{ marginBottom: "10px" }}>
      <label className="input-label">{label} :</label>
      {isMultiple ? (
        <MultiSelect
          placeholder={placeholder}
          value={value}                 
          options={options}             
          optionLabel="label"
          optionValue="value"
          disabled={disabled}
          onChange={(e) => onChange(e.value)}   
          maxSelectedLabels={3}
          filter
          showSelectAll={false}
          selectAllLabel="Select All"
          display="chip"
          className="input-style"
        />
      ) : (
        <Dropdown
          placeholder={placeholder}
          value={value}
          options={options}
          optionLabel="label"
          optionValue="value"
          filter
          onChange={(e) => onChange(e.value)}
          className="input-style"
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default LabeledDropdown;
